import Vue from "vue";
let currentRequest = 0;

const TagService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("tag", id);
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START TAG `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "tags",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] TAG DISCARDED`);
        return null;
      }
      console.log(`[${request}] END TAG `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  }
};

export { TagService };
